// Chakra imports
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Text,
  useColorModeValue,
  useConst,
} from '@chakra-ui/react';
// Assets
import BgSignUp from '../../assets/img/BgSignUp.png';
import React, { useContext, useEffect } from 'react';
import { FaApple, FaFacebook, FaGoogle } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import { Globle_app_context } from '../../context/globle_context';
import OtpVerification from './otp_verification';

export default function SignUp() {
  const titleColor = useColorModeValue('teal.300', 'teal.200');
  const textColor = useColorModeValue('gray.700', 'white');
  const bgColor = useColorModeValue('white', 'gray.700');
  const bgIcons = useColorModeValue('teal.200', 'rgba(255, 255, 255, 0.5)');
  const {
    signUp_state,
    hendleSign_upForm_input,
    user_signup,
    sign_up_state_loading,
  } = useContext(Globle_app_context);
  let navigate = useNavigate();
  useEffect(() => {
    let is_auth = localStorage.getItem('my_auth') || undefined;
    if (is_auth) {
      navigate('/home');
    }
  }, []);
  return signUp_state == 'sign_up' ? (
    <Flex
      w="100%"
      className="h-[100vh]"
      alignItems="center"
      justifyContent="center"
    >
      <Flex
        alignItems="center"
        direction="column"
        w="445px"
        background="transparent"
        borderRadius="15px"
        p="40px"
        mx={{ base: '100px' }}
        bg={bgColor}
        boxShadow="0 20px 27px 0 rgb(0 0 0 / 5%)"
      >
        <Text
          fontSize="xl"
          className="text-[#51bcfa]"
          fontWeight="bold"
          textAlign="center"
          mb="22px"
        >
          Register
        </Text>
        <FormControl>
          <form onSubmit={(e) => user_signup(e)}>
            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
              Name
            </FormLabel>
            <Input
              onChange={(e) => hendleSign_upForm_input(e)}
              name="name"
              fontSize="sm"
              ms="4px"
              borderRadius="15px"
              type="text"
              placeholder="Your full name"
              mb="24px"
              size="lg"
            />
            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
              Email
            </FormLabel>
            <Input
              name="username"
              onChange={(e) => hendleSign_upForm_input(e)}
              fontSize="sm"
              ms="4px"
              borderRadius="15px"
              type="email"
              placeholder="Your email address"
              mb="24px"
              size="lg"
            />
            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
              Password
            </FormLabel>
            <Input
              name="password"
              onChange={(e) => hendleSign_upForm_input(e)}
              fontSize="sm"
              ms="4px"
              borderRadius="15px"
              type="password"
              placeholder="Your password"
              mb="24px"
              size="lg"
            />
            <FormControl
              display="flex"
              alignItems="center"
              mb="24px"
            ></FormControl>
            <Button
              isLoading={sign_up_state_loading}
              isDisabled={sign_up_state_loading}
              type="submit"
              bg="#51bcfa"
              fontSize="10px"
              color="white"
              fontWeight="bold"
              w="100%"
              h="45"
              mb="24px"
              _hover={{
                bg: '#51bcfa',
              }}
              _active={{
                bg: '#51bcfa',
              }}
            >
              SIGN UP
            </Button>
          </form>
        </FormControl>
        <Flex
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          maxW="100%"
          mt="0px"
        >
          <Text color={textColor} fontWeight="medium">
            Already have an account?
            <Link to={'/signin'}>
              <Text
                className="text-[#51bcfa]"
                as="span"
                ms="5px"
                fontWeight="bold"
              >
                Sign In
              </Text>
            </Link>
          </Text>
        </Flex>
      </Flex>
    </Flex>
  ) : (
    <OtpVerification />
  );
}
